import React from 'react';

import { type ContentItem, ContentType, type LinkContent, type NFTContent } from '@app/store/types/yat-page-actions';

import { YatGridItemLink } from './Link';
import { YatGridItemNFT } from './NFT';

type LinkItem = ContentItem<LinkContent>;
type NftItem = ContentItem<NFTContent>;

interface Props {
    item: ContentItem;
    editMode?: boolean;
}

export const GridItem = ({ item, editMode }: Props) => {
    if (!item) return null;
    return item.type === ContentType.LINK ? (
        <YatGridItemLink item={item as LinkItem} editMode={editMode} />
    ) : (
        <YatGridItemNFT item={item as NftItem} editMode={editMode} />
    );
};
